//图片转base64位图
export function downloadBase64(val){
  return new Promise((resolve, reject) => {
    try{
      const c = document.createElement("canvas");
      const url = val;
      const img = new Image();
      img.src = url;
      // 图片跨域使用
      img.crossOrigin = "anonymous";
      const imgBase = [];
      img.addEventListener('load', async (e) => {
          if (e.path) {
              for (const i in e.path) {
                  const imgE = e.path[i];
                  const width = imgE.width;
                  const height = imgE.height;
                  c.width = width;
                  c.height = height;
                  const base = await canvasFun(c, e.path[i], width, height);
                  imgBase.push(base);
              }
              resolve(imgBase)
          } else {
              reject("没有图片数据");
          }
      }, false)
    } catch(e){
      resolve([""])
    }
  });
  function canvasFun (dom, imgs, w, h) {
      const canvas = dom.getContext('2d');
      canvas.drawImage(imgs, 0, 0, w, h);
      return dom.toDataURL("image/png", 1);
  }
}